import i18next from 'i18next';
import ICU from 'i18next-icu';
import PropTypes from 'prop-types';
import { I18nextProvider } from 'react-i18next';
import en from './en/en.json';
import fi from './fi/fi.json';

i18next.use(ICU).init({
  interpolation: { escapeValue: false }, // React already does escaping
  // TODO: update and use a language detector later https://github.com/i18next/i18next-browser-languageDetector
  lng: 'fi',
  // This will be loaded on page load
  resources: {
    en: {
      common: en,
      // Common is custom name space, called by hook
      // Adding a new translation file === add a new namespace here
      // This shound enable smaller translation files if we want and load translation that are not need on first load > speed up load time
    },
    fi: {
      common: fi,
    },
  },
  // This will be loaded after init
  // i18next.addResourceBundle('en', 'namespace1', {
  //   key: 'hello from namespace 1'
  // });
});

export const TranslationProvider = ({ children }) => (
  <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
);

TranslationProvider.propTypes = {
  children: PropTypes.array.isRequired,
};
